/**
 * @generated SignedSource<<438c2ee072c1b1c3100c80727c6c0483>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
import { FragmentRefs } from "relay-runtime";
export type salesChannelsActive$data = {
  readonly isSellerMigrating: boolean;
  readonly productSwitcherTasks: ReadonlyArray<{
    readonly elapsedTime: number;
    readonly extraData: {
      readonly delayMinutes: number;
      readonly destinationSalesChannelID: number;
      readonly isSourceSalesChannelDisabled: boolean;
      readonly masterSalesChannelID: number;
      readonly paymentMethodSetupTaskID: number | null;
      readonly secondarySalesChannelID: number;
      readonly sourceSalesChannelID: number;
      readonly taskID: number;
    };
    readonly lastError: string;
    readonly modifiedOn: string;
    readonly state: number;
    readonly taskID: number;
    readonly taskType: string;
  }> | null;
  readonly salesChannels: ReadonlyArray<{
    readonly detail: {
      readonly id: string;
      readonly properties: {
        readonly name: string | null;
        readonly storePosition: number | null;
      } | null;
    } | null;
    readonly ecommerceSettings: {
      readonly currencyCode: string | null;
      readonly currencyID: number;
      readonly definitiveUrl: string | null;
      readonly ecommerceGlobalID: string;
      readonly ecommerceID: number;
      readonly ecommerceName: ECommerce;
      readonly id: string;
      readonly isMarketplace: boolean;
      readonly remoteUrl: string | null;
    } | null;
    readonly id: string;
  }>;
  readonly user: {
    readonly email: string;
    readonly userID: number;
  };
  readonly " $fragmentType": "salesChannelsActive";
};
export type salesChannelsActive$key = {
  readonly " $data"?: salesChannelsActive$data;
  readonly " $fragmentSpreads": FragmentRefs<"salesChannelsActive">;
};

import salesChannelActiveFragmentQuery_graphql from './salesChannelActiveFragmentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskID",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": salesChannelActiveFragmentQuery_graphql
    }
  },
  "name": "salesChannelsActive",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserInfo",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": "ACTIVE"
        }
      ],
      "concreteType": "SalesChannel",
      "kind": "LinkedField",
      "name": "salesChannels",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesChannelDetail",
          "kind": "LinkedField",
          "name": "detail",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SalesChannelDetailProperties",
              "kind": "LinkedField",
              "name": "properties",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "storePosition",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EcommerceSettings",
          "kind": "LinkedField",
          "name": "ecommerceSettings",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ecommerceGlobalID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ecommerceID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ecommerceName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remoteUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isMarketplace",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "definitiveUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currencyID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currencyCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "salesChannels(status:\"ACTIVE\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSwitcherTask",
      "kind": "LinkedField",
      "name": "productSwitcherTasks",
      "plural": true,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taskType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastError",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "elapsedTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "modifiedOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSwitcherTaskExtraData",
          "kind": "LinkedField",
          "name": "extraData",
          "plural": false,
          "selections": [
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "masterSalesChannelID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "secondarySalesChannelID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "delayMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "paymentMethodSetupTaskID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sourceSalesChannelID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "destinationSalesChannelID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSourceSalesChannelDisabled",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSellerMigrating",
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "2755ccf05ab30552c9c1bd16435008d4";

export default node;
